/** 支付完成、轮次结束后通知当前用户页面重读平台事实，事件不携带金额或身份。 */
export function notifyCreditRefresh(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('bomate:credit-refresh'));
}
/** 统一账户/侧栏的刷新订阅；返回清理函数避免重复监听。 */
export function subscribeCreditRefresh(refresh: () => void): () => void {
  window.addEventListener('bomate:credit-refresh', refresh);
  return () => window.removeEventListener('bomate:credit-refresh', refresh);
}
